// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__378d1","header":"Messages_header__2smhc"};